/** Lucide icon sizes and stroke the chat components share with the apps that render them. */
export const ICON_SIZES = {
  sm: 14,
  md: 16,
  lg: 18,
} as const;

export const ICON_STROKE = 1;
